import { validateServerData } from '@wwt/core/admin'
import { OfferCreateResponseDto } from '@wwt/entities/api/search-response'
import { Offer } from '@wwt/entities/search-response'

import { api } from '@/shared/api/client.ts'

import { offerToOfferRequest } from '../utils/offerToRequest.ts'

export const saveOfferQuery = async (offer: Offer) => {
	const response = await api()
		.post(offerToOfferRequest(offer), '/v1/offers')
		.json()

	return validateServerData(response, OfferCreateResponseDto, 'Save offer')
}
